<template>
  <section>
    <div class="controls">
      <button id="button" @click="openCamera">Get camera</button>
      <select id="select">
        <option></option>
      </select>
    </div>
    <video id="video" autoplay playsinline></video>
  </section>
</template>

<script>

  export default {
    name: "FaceDisclose",
    data() {
      return {
        videoEl: {},
        canvasEL: {},
      }
    },
    methods: {
      openCamera() {
        const video = document.getElementById('video');
        const button = document.getElementById('button');
        const select = document.getElementById('select');
        let currentStream;

        if (typeof currentStream !== 'undefined') {
         this.stopMediaTracks(currentStream);
        }
        const videoConstraints = {};

        if (select.value === '') {
          videoConstraints.facingMode = 'environment';
        } else {
          videoConstraints.deviceId = { exact: select.value };
        }
        const constraints = {
          video: videoConstraints,
          audio: false
        };
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            currentStream = stream;
            video.srcObject = stream;
            return navigator.mediaDevices.enumerateDevices();
          })
          .then(this.gotDevices)
          .catch(error => {
            console.log(error);
          });
      },
      stopMediaTracks:function(stream) {
        stream.getTracks().forEach(track => {
            track.stop();
        });
      },
      gotDevices:function(mediaDevices) {
        select.innerHTML = '';
        select.appendChild(document.createElement('option'));
        let count = 1;
        mediaDevices.forEach(mediaDevice => {
          if (mediaDevice.kind === 'videoinput') {
            const option = document.createElement('option');
            option.value = mediaDevice.deviceId;
            const label = mediaDevice.label || `Camera ${count++}`;
            const textNode = document.createTextNode(label);
            option.appendChild(textNode);
            select.appendChild(option);
          }
        });
      }
    },
    mounted() {
      //this.openCamera();
    },
    destroyed() {

    }
  }
</script>

<style scoped>
  video {
    width: 100%;
    max-width: 600px;
    display: block;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/qrcodeview/FaceDisclose.vue